import React from "react";
export const constants = {
  format: (source, params) => {
    // eslint-disable-next-line no-sequences
    return source, [...params];
  },
  FIRST_NAME: "First Name",
  CLICK_TO_VIEW_TEXT: "Click to view",
  NAME_OF_CLIENT: "Name of client",
  DATE_TIME_SESSION: "Date time session",
  CLICK_TO_ADD_TEXT: "Click to add",
  NAME: "Name",
  EMAIL_ADDRESS: "Email Address",
  EMPLOYEE_ID_TXT: "Employee ID",
  EMAIL_CONFIRMATION: "Email Confirmation",
  SENT_LINK: "Link sent",
  NEW_PASS_MESSG: "Your identity has been verified! Set your new password",
  EMAIL_CONFIRM_MSG:
    " We have sent you an email for confirmation.To {0} please follow the link in your email",
  CREATE_ACCOUNT: "Create your account",
  SIGN_UP_MSG: "Sign up to join with people who {0} already feel happier.",
  FORGOT_TAGLINE:
    "Please enter the email address you used to register. We’ll send a link with instructions to reset your password.",
  ENTER_PASSWORD: "Enter Password",
  REMEMBER_ME: "Remember me",
  FORGOT_PASSWORD: "Forgot password?",
  USER_NAME: "User Name",
  CONFIRM_PASSWORD: "Confirm Password",
  VIEW_BLOGS:"View Blogs",
  FAQ_TXT:"FAQ",
  SIGN_IN_TXT:"Sign In",
  PASSWORD: "Password",
  REGISTER: "Register",
  SIGN_IN_MSG: "Already a member? ",
  STUDENT: "student",
  SUBSIDIARY: "subsidiary",
  PATIENT: "patient",
  PAKQATAR: "PakQatar",
  COUNSELLOR: "Counsellor",
  FORGOT_PASS_BTN: "Request password reset",
  IBA: "IBA",
  EMAIL: "email",
  ENTER_YOU_EMAIL: "Please enter your {0} email",
  TERMS_CONDITIONS_MSG: "Please check our Terms and condition",
  FILL_ALL_FIELDS_MSG: "Please fill all the fields",
  INVALID_EMAIL: "You have entered an invalid email address!",
  PASSWORD_LIMIT_MSG: "Ensure the password fields has at least 6 characters.",
  PASSWORD_DONOT_MATCH_MSG: "The passwords do not match.",
  REGISTER_MEMBER_MSG: "Register a new membership",
  SIGN_IN_SESSION: "Sign in to start your session",
  SIGN_IN: "Sign In",
  COUNSELOR_LOGIN_MSG: "Are you a {0}?",
  DID_YOU_KNOW_ABT_FAQ: "Did you know about FAQs?",
  CLICK_HERE_TXT: "Click here",
  WANT_TO_READ_BLOGS: "Do you want to read blogs?",
  FORGOT_PASSWORD_MSG: "Forgot your Password?",
  CHECKING_TERMS_TXT: "By checking this, you agree to our ",
  TERMS_CONDITIONS_TXT: "Terms and Condition",
  REGISTERED: "registered",
  PLEASE_TXT: "Please",
  CHOOSE_YOUR_PROJECT: "CHOOSE YOUR PROJECT(S)",
  MARK_PROJECT_AVAILABILITY: "UPDATE PROJECT(S) STATUS",
  NO_PROJECT_SELECTED: "You didnt selected any project",
  SAAYA_HEALTH_TXT: "Saaya Health",
  OTHER_FIELD_TEXT_ERROR:"Value for other field can not be empty",
  EMPTY_NATURE_TEXT_ERROR:"Select any one of the nature.",
  OTHER_TXT: "other",
  MOBILE_USER_NAME: "Name",
  MOBILE_SIGN_IN_SESSION:
    "Continue your journey towards a happier & healthier you!",
  MOBILE_ENTER_YOU_EMAIL: "Email",
  MOBILE_EMAIL_ADDRESS: "Email",
  MOBILE_COUNSELOR_LOGIN_MSG: "Are you a {0}?",
  MOBILE_COUNSELOR_LOGIN_MSG_LINK: "Sign In here",
  MOBILE_FORGOT_PASSWORD_MSG: "Forgot Password",
  MOBILE_REGISTER_MEMBER_MSG:
    "Continue your journey towards a happier & healthier you!",
  MOBILE_CONFIRM_PASSWORD: "Confirm Password",
  MOBILE_PASSWORD: "Password",
  MOBILE_CHECKING_TERMS_TXT: "By checking this,agree to the terms of use and ",
  MOBILE_TERMS_CONDITIONS_TXT: "privacy policy.",
  MOBILE_SIGN_IN_MSG: "Already a member? ",
  MOBILE_SIGN_IN_MSG_LINK: "Sign In here",
  EMAIL_VALIDATION_MSG: "Enter a valid email address",
  COUNSELLOR_LOGIN: "Counsellor Login",
  FAQ_TEXT: "Frequently Asked Questions",
  NOTES_TEXT: "your notes",
  SCHEDULE_SESSION_TEXT: "schedule a session",
  HELP_TEXT: "We’re here to help",
  CONTACT_US_TEXT: "Contact Us",
  SUBMIT_TEXT: "Submit",
  OKAY_TEXT: "Okay",
  TOP_QUESTIONS_TEXT: "Top Questions",
  SUCCESS_TEXT: "success",
  VIEW_BLOGS_TXT: "View Blogs",
  ERROR_TEXT: "error",
  CONTACT_US_SUCCESS_MSG: "Your request has been successfully sent",
  CONTACT_US_FAILURE_MSG: "Your request cannot be registered at this time",
  UNSUPPORTED_MSG_TITLE: "Oh Snap!",
  UNSUPPORTED_MSG_BODY:
    "We can not find your camera or microphone to initiate this call. Please check if you have given the permissions, or contact us at contact@saayahealth.com with screenshot.",
  FAQ_EMPTY_MSG: "There are no queries registered at the moment",
  DESCRIPTION_LENGTH_ERROR_MSG:
    "Description should contain atleast 10 characters",
  NO_PATIENTS_MSG: "No Patient Available",
  PST_MSG: "Pakistan Standard Time",
  CREATE_APPOINTMENT_TXT: "Create Appointment",
  SELECT_DAY_TXT: "Select Day",
  SELECT_TIME: "Select Time",
  SELECT_USER_TXT: "Select User",
  CANCEL_TXT: "Cancel",
  DETAILS_TXT: "Details",
  APPOINTMENT_DETAILS_TXT: "Appointment Details",
  PATIENT_DETAILS_TXT: "Patient Details",
  JOIN_TXT: "Join",
  EDIT_TXT: "Edit",
  SUBMIT_TXT: "Submit",
  MANAGE_SCHEDULE_TXT: "Manage your schedule",
  MANAGE_AVAILABILITY_TXT: "Manage your availability for new clients",
  VIEW_SLOTS_TXT: "View Slots",
  REGISTER_SLOTS: "Register Slots",
  YOUR_NEXT_SESSION_TXT: "Your next session",
  PATIENT_NAME_TXT: "Patient Name",
  WHEN_TXT: "When",
  NO_APPOINTMENTS_TXT: "No appointments to show",
  SELECT_USER_ERROR_MSG: "Select a user to continue the request.",
  NO_SUBSIDIARY_TXT: "No Subsidiary to select",
  SELECT_SUBSIDIARY_ERROR_MSG: "Select a subsidiary to continue the request.",
  SUBSIDIARY_PLACEHOLDER_TXT: "Select subsidiary",
  ENTER_NEW_PWD_TXT: "Enter Your New Password",
  ENTER_NEW_PWD: "Enter new Password",
  NEW_PWD_TXT: "New password",
  REPEAT_PWD_TXT: "Repeat Password",
  CONFIRM_PWD: "Confirm password",
  UPDATE_PWD_TXT: "Update password",
  SELECTED_TXT: "Selected",
  SELECT_TXT: "Select",
  REOURCE_IN_USE_ERROR:
    "We could not connect to your selected camera since it may be in use by another application.",
  RESEOURCE_NOT_FOUND_ERROR:
    "We could not find any camera or microphone connected to your device.",
  SESSION_GENERAL_ERROR:
    "We are unable to join the session at the moment, Please try again",
  UNASSGNED_COUNSELLOR_MSG:
    "You are not assigned to any projects at the moment!",
  COUNSELLOR_FEE_TXT: "Per Session",
  CONGRATULATION: "Congratulations!",
  CHANGE_PASSWORD_TXT: "Change Password",
  LOGOUT_TXT: "Logout",
  USER_VERIFICATION_TXT:
    "We have sent you an email for confirmation. To register your account please follow the link in your email.",
  NEED_HELP_TXT: "Need help?",
  CONTACT_EMAIL: "contact@saayahealth.com",
  CHECK_EMAIL_TXT: "Please check your email to confirm your account.",
  CHECK_EMAIL_BODY: `Thank you for your registration. We have sent you an email
for confirmation.To activate your account please follow the
link in your email.`,
  CHECK_EMAIL_FOOTER:
    "If you have not received your email please check your spam or contact us at",
  PASSWORD_CHANGED_MSG: "Congratulations! Your password has been changed.",
  PASSWORD_RESET_TXT: "Password Reset",
  PASSWORD_CHANGED_SUCCESS_MSG: "Your password has been reset sucessfully.",
  ACCOUNT_VERIFIED_TXT: "Your account has been verified.",
  EDIT_SESSION_TXT: "Edit your appointment",
  SESSION_CAP_TXT: "Session cap",
  SELECT_NATURE_OF_ISSUE_TXT: "Select nature of issue",
  REQUEST_COUNSELLOR: "Request A Session",
  PLZ_CHOOSE_SESSION_TXT: "Please choose your session",
  NO_SESSION_AVAILABLE_TXT: "There are no slots available",
  REQUEST_A_SESSION_BTN: "Request A Session",
  CLICK_ON_ARRANGE_SESSION_TEXT : "Please click below to get in touch with your counsellor",
  CLICK_ON_ARRANGE_SESSION_DIFFERENT_DATE : "By clicking the below button you can request a different date.",
  CONFIRM_ARRANGE_SESSION_MODAL_TEXT : "You want to arrange a session!",
  ARRANGE_A_SESSION_BTN_TEXT:'Find Another Time',
  ARRANGE_SESSION_SUCCESS_MESSAGE_MODAL:"Session request has been sent.",
  ARRANGE_SESSION_FAILIUR_MESSAGE_MODAL:"Session request cannot be sent at this time.",
  YOUR_CHOOSEN_TIME_TXT: "Your chosen time is",
  TIME_SLOTS_TXT: "TIME SLOTS",
  CHOOSE_NEW_SCHEDULE_TXT: "Choose new schedule",
  INVALID_TIME_SLOT_MSG: "Please select a valid time slot",
  DELETE_CONFORM_HEADER_TXT: "Are you sure?",
  ARRANGE_SESSION_CONFORM_HEADER_TXT: "Are you sure?",
  LEAVE_SCREEN_MSG: "You want to leave this screen!",
  TELL_ABOUR_YOURSELF_TXT: "Tell us about yourself",
  LIST_OF_COUNTRIES_TXT: "Select your country",
  SIGN_IN_TEXT: "Sign in to your account",
  CONTINUE_JOURNEY_TXT_1: "Continue your journey towards",
  CONTINUE_JOURNEY_TXT_2: "a happier & healthier you!",
  EMAIL_VERIFY_TXT: `Please enter the email address you used to register. We’ll send a link with instructions to reset your password.`,
  CUSTOMER_SUPPORT_TXT: "Customer support",
  EMAIL_CONFIRMATION_TXT:
    "If you have not received your email please check your spam or contact ",
  COUNSELLOR_PROFILE_TXT: "Counsellor Profile",
  BOOK_NOW_TXT: "Book Now",
  VIEW_PROFILE_TXT: "View Profile",
  PASSWORD_CHANGED_TXT: "Your password has been changed",
  ALL_SET_TXT: "All set!",
  SAVE_TXT: "Save",
  IDENTITY_VERIFIED_TXT: "Your identity has been verified!",
  SET_NEW_PWD_TXT: "Set your new password",
  ORGANIZATION_TXT: "Organization",
  REGISTERED_SLOTS_TXT: "Your registered slots",
  SLOT_DELETE_CONFIRM_TXT: "You want to delete your slot!",
  SESSION_UPDATE_CONFIRM_TXT: "You want to update the session status?",
  SESSION_UPDATE_NATURE_CONFIRM_TXT: "Do you want to update the nature of issue?",
  NO_SLOTS_TXT: "You do not have any registered slots",
  SINCE_TXT: "Since",
  LANGUAGES_TXT: "Language",
  FOCUSED_AREAS: "Focused Areas",
  ERROR404_TXT: "404",
  SHOW_RESULT_TEXT :"Search",
  CLEAR_FILTER_TEXT: "Clear",
  EXPORT_EXCEL_TXT: "Export Excel",
  PAGE_NOT_FOUND_TXT: "Page Not Found",
  DELETE_TXT: "Delete",
  VIEW_TXT: "View",
  EMPTY_NOTES_TXT: "You do not have any notes.",
  COUNSELLOR_FEEDBACK_HEADING: "FEEDBACK",
  COUNSELLOR_FEEDBACK_TEXT:
    "Not satisfied with the service? Tell us what happened",
  COUNSELLOR_FEEDBACK_BTN_TEXT: "Start Feedback",
  COUNSELLOR_FEEDBACK_URL:
    "https://docs.google.com/forms/d/e/1FAIpQLSdj1r6tIcXJVCybSbtnMshwA-lzXrMYK7p5AqH5_oKXvTXO0Q/viewform?usp=sf_link",
  PATIENT_FEEDBACK_HEADING: "FEEDBACK",
  PATIENT_FEEDBACK_TEXT:
    "Not satisfied with the service? Tell us what happened",
  PATIENT_FEEDBACK_BTN_TEXT: "Start Feedback",
  PATIENT_FEEDBACK_URL:
    "https://docs.google.com/forms/d/e/1FAIpQLSdj1r6tIcXJVCybSbtnMshwA-lzXrMYK7p5AqH5_oKXvTXO0Q/viewform?usp=sf_link",
  FOREE_CHECKOUT: "Pay with foree pay",
  LANGUAGES_ERROR_TXT: 'Please select language',
  SELECT_LANGUAGE_TXT: 'Select Language',
  SELECT_SERVICE_TYPE_TXT: 'Select Service Type',
  YOUR_SESSIONS: "Your Sessions",
  YOUR_PREVIOUS_SESSIONS:"Your previous sessions",
  EMPTY_SESSIONS_TEXT: "You do not have any sessions.",
  STATUS: "Status",
  NATURE_OF_ISSUE_TXT:"Nature of Issue",
  SUBSIDIARY_NAME_TXT: "Subsidiary Name",
  PROJECT_TXT: "Project",
  CLIENT_NAME: 'Name of Client',
  PAST_SESSIONS:"Past Sessions",
  DATE_TIME_SESSION_TEXT:'Date/Time of Session',
  TYPE_WARNING: 'warning',
  CONFIRM_BUTTON_COLOUR: '#36A692',
  CANCEL_BUTTON_COLOUR: '#d33',
  CANCEL_BUTTON_TEXT: 'No',
  CONFIRM_BUTTON_TEXT: 'Yes',
  REVERSE_BUTTON_STATUS: true,
  SHOW_CANCEL_BUTTON: true,
  BACKDROP_STATE:false,
  SELECT_STYLES_BORDER_BOTTOM:'1px',
  SELECT_STYLES_IS_SELECT_COLOR:'black',
  SELECT_STYLES_IS_DISABLED_COLOR:'grey',
  SELECT_STYLES_IS_SELECTED_BG_COLOR:"#eee",
  SELECT_STYLES_TEXT_ALIGN:'left',
  SELECT_STYLES_IS_DISABLED_CURSOR:'auto',
  SELECT_STYLES_DEFAULT_CURSOR:'pointer',
  SELECT_STYLES_CONTAINER_WIDTH:'70%',
  SELECT_STYLES_CONTROL_HEIGHT:38,
  SELECT_STYLES_CONTROL_FONT_SIZE:15,
  SELECT_STYLES_CONTROL_BORDER_RADIUS:'4px',
  SELECT_STYLES_CONTROL_WIDTH:"100%",
  SELECT_STYLES_CONTROL_TEXT_ALIGN:'left',
  SELECT_STYLES_CONTROL_CURSOR:'pointer',
  NOTE_AVAILABLE_TEXT:'N/A',
  DATE_FORMAT_OFR_MOMENT:'ddd DD MMM YYYY hh:mm:ss A',
  MOMENT_LOCAL_STRING_TYPE:'en-US',
  MOMENT_LOCAL_HOUR_TYPE:'numeric',
  MOMENT_IS_12_HOUR_FORMAT:true,
  SWAL_STATUS_UPDATE_SUCCESS_MESSAGE:'Status has been updated!',
  SWAL_NATURE_UPDATE_SUCCESS_MESSAGE:'Nature of issue has been updated!',
  SWAL_STATUS_UPDATE_FAILURE_MESSAGE:'Status has not been updated!',
  SWAL_NATURE_UPDATE_FAILURE_MESSAGE:'Nature of issue has not been updated!',
  SWAL_SUCCESS_TEXT:'success',
  SWAL_ERROR_TEXT:'error',
  MODAL_SUCCESS_AFTER_TEXT_SWAL:'Saaya Health',
  PAGINATION_ITEMS_COUNT:10,
  PAGINATION_PREVIOUS_LABEL:'Previous',
  PAGINATION_PREVIOUS_LABEL_MOB:'<',
  PAGINATION_BREAK_LABEL:'...',
  PAGINATION_NEXT_LABEL:'Next',
  PAGINATION_NEXT_LABEL_MOB:'>',
  PAGINATION_MARGIN_PAGES_DISPLAYED:1,
  ADD_FMAILY_MEMBER_TXT: 'Add Family Member',
  VIEW_FMAILY_MEMBER_TXT: 'View Family Member',
  EMPTY_FMAILY_MEMBER_TXT: "No family members added, please click button to add.",
  ADD_MEMBER_TXT: 'Add Member',
  FMAILY_MEMBER_NAME_TXT: 'Name',
  FMAILY_MEMBER_RELATION_TXT: 'Relation',
  FMAILY_MEMBER_EMAIL_TXT: 'Email',
  FMAILY_MEMBER_DELETE_SUCCESS_TXT:'Your family member has been removed.',
  FMAILY_MEMBER_DEFAULT_DELETE_ERROR_TXT:'There was an issue deleting the family member.',
  FMAILY_MEMBER_NOT_FOUND_TXT:'Member not found',
  FMAILY_MEMBER_IVALID_NAME_TXT:'Name can not be empty',
  FMAILY_MEMBER_IVALID_EMIAL_TXT:'Enter a valid email address',
  FMAILY_MEMBER_IVALID_RELATION_TXT:'Relation can not be empty',
  FMAILY_MEMBER_NAME_EMAIL_ALREADYEXIST_TXT:'Username and email address are not valid.',
  FMAILY_MEMBER_ADD_SUCCESS_TXT:"Family member added successfully. Invitation sent to the family member with login details.",
  ENTER_NAME_TXT:'Enter name',
  ENTER_EMAIL_TXT:'Enter email',
  SELECT_REALTION_TXT:'Select relation',
  FMAILY_MEMBER_ERROR_TEXT:'Error',
  OK_TXT:"Ok",
  YES_TXT:"Yes",
  NO_TXT:"No",
  QUESTION_TYPE_TXT:'type',
  GENERAL_ERROR_TXT:'An error occurred while processing.',
  DELETE_CONFRIM_TXT_ONE:'Are you sure you want to remove',
  DELETE_CONFRIM_TXT_TWO:'from your family member list?',


  SUBSCRIPTION_TXT: "Subscription",
  MONTHLY_SESSION_EXPIRED_TXT: "The Maximum Allowed Sessions have been completed. Please email your counsellor or contact@saayahealth.com for help.",
  SESSION_CAPS_RESET_TXT: "Session caps reset successfully",
  RESET_SESSION_CAP_TXT: "Reset session cap",
  HAVE_YOU_TAKEN_PERMISSION_TXT: "Have you taken written permission from Saaya Management?",
  SESSION_RESET_FAILED_TXT: "Can't reset the session cap.",

  SERVICE_NOT_SUBSCRIBED_MESSAGE: (type) => `Dear Client, ${type} services are not subscribed by your company. Email contact@saayahealth.com if you would like them activated.`,
  NO_SESSION_CAP_TXT:'No. of sessions are not capped.',
  MAXIMUM_ALLOWED_SESSIONS_TXT:'Maximum sessions allowed:',
  TOTAL_REMAINING_TXT:'Total sessions remaining:',
  ACTIVE_RELATIONSHIP_MESSAGE:"You already have an active relationship with a counsellor for this service type. To switch counsellors, please delete your current relationship.",
  SESSION_EXPIRED_TXT:'Session expired',
  LOGIN_AGAIN_TXT:'Kindly log in to continue using the platform.',
  END_CALL_TXT: "End call",
  MUTE_MICROPHONE_TXT: {
    OFF: "Mute microphone",
    ON: "Unmute microphone",
  },
  ADD_NOTES_TXT: "Add notes",
  MUTE_VIDEO_TXT: {
    OFF: "Turn off camera",
    ON: "Turn on camera",
  },
  SWAP_CAMERA_TXT: "Swap Camera",
  FULL_SCREEN_TXT: {
    OFF: "Full screen",
    ON: "Exit full screen",
  },
  BOOKING_DETAILS_TXT: 'Booking details',
  ADD_FAMILY_MEMBER_ALLOWED_TXT: 'Allowing family member is not subscribed by your corporate.',
  APPOITMENT_CREATED_SUCCESSFULLY_TXT:'Appointment has been created successfully!',
  SELECTED_SCHEDULE_TXT: 'Selected Schedule:'
};

export const ANALYTICS_EVENTS = {
  PAGE_VISITS: {
    LOGIN_PAGE: 'patient_portal_login_page_visit',
    HOME_PAGE: 'patient_portal_home_page_visit',
  },
  BUTTON_CLICKS: {
    SIGN_IN_BTN: 'patient_portal_signIn_btn_click',
    FAQ_BTN: 'patient_portal_FAQ_btn_click',
    VIEW_BLOGS_BTN: 'patient_portal_view_blogs_btn_click',
    SCHEDULE_SESSION_BTN: 'patient_portal_schedule_session_btn_click',
    OPEN_NOTE_BTN: 'patient_portal_open_note_btn_click',
    LEARN_ABOUT_WELLBEING_BTN: 'patient_portal_learn-about-wellbeing_btn_click',
    FEEDBACK_BTN: 'patient_portal_feedback_btn_click',
    SERVICE_TYPE_BTN: 'patient_portal_service_type_click',
  },
};



// WEBPACK FOOTER //
// ./src/Constants.js